/*
 * Public API Surface of @coreui/icons-angular
 */
export { IconDirective } from './lib/icon/icon.directive';
export { IconComponent } from './lib/icon/icon.component';
export { IconModule } from './lib/icon/icon.module';
export { IconSetService, IIconSet } from './lib/icon-set/icon-set.service';
export { IconSetModule } from './lib/icon-set/icon-set.module';
